// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedConnectionsAddOnError_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.98964 2C9.77945 2 11.386 2.78571 12.484 4.03146 12.8898 3.47484 13.5197 3.09246 14.2408 3.01742 12.777 1.17851 10.5208 0 7.98964 0 6.67085 0 5.42669.319935 4.33035.886519 4.91159 1.25518 5.3303 1.8576 5.45464 2.56178 6.22455 2.20134 7.08361 2 7.98964 2ZM0 8C0 6.6795.319521 5.43373.885371 4.33596 1.25355 4.91796 1.8552 5.33721 2.55846 5.46172 2.19849 6.23262 1.99741 7.0928 1.99741 8 1.99741 9.78513 2.77598 11.3882 4.01167 12.4873 3.45738 12.8969 3.07836 13.5306 3.00797 14.2549 1.17462 12.789 0 10.5318 0 8ZM4.49417 3C4.49417 3.82843 3.82347 4.5 2.99611 4.5 2.16876 4.5 1.49806 3.82843 1.49806 3 1.49806 2.17157 2.16876 1.5 2.99611 1.5 3.82347 1.5 4.49417 2.17157 4.49417 3ZM5.33732 13.008C5.64312 13.8704 6.14033 14.642 6.77777 15.2716 6.51582 15.708 6.0384 16 5.49288 16 4.66552 16 3.99482 15.3284 3.99482 14.5 3.99482 13.7242 4.58306 13.0859 5.33732 13.008ZM15.2619 6.79682C14.6362 6.15867 13.8692 5.65996 13.0115 5.35153 13.0878 4.59467 13.726 4.00391 14.5019 4.00391 15.3293 4.00391 16 4.67548 16 5.50391 16 6.05457 15.7037 6.53593 15.2619 6.79682Z" class="svg-bg"/>
  <circle cx="11" cy="11" r="5" fill="#ED5353"/>
  <circle cx="11" cy="11" r="5" stroke="white"/>
  <path d="M9.15956 7.90625L7.92212 9.14369L9.77827 10.9998L7.92212 12.856L9.15956 14.0934L11.0157 12.2373L12.8719 14.0934L14.1093 12.856L12.2531 10.9998L14.1093 9.14369L12.8719 7.90625L11.0157 9.76241L9.15956 7.90625Z" class="svg-fg"/>
</svg>
`;
/**
 * IconMedConnectionsAddOnError is a generated icon component.
 */
let IconMedConnectionsAddOnError = IconMedConnectionsAddOnError_1 = class IconMedConnectionsAddOnError extends IconBaseElement {
    render() {
        return html `${IconMedConnectionsAddOnError_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedConnectionsAddOnError.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconMedConnectionsAddOnError = IconMedConnectionsAddOnError_1 = __decorate([
    customElement('zui-icon-med-connections-add-on-error')
], IconMedConnectionsAddOnError);
export { IconMedConnectionsAddOnError };
